import R from 'ramda'

const COMMENTS_ON_DISPLAY_TYPE = 'Comments On Post'

const INITIAL_POST_TRIGGER_TYPE = 'FB_INITIAL_POST'
const COMMENTS_ON_TRIGGER_TYPE = 'COMMENTS_ON'

const isCommentsOnFormTrigger = R.propEq('type', COMMENTS_ON_DISPLAY_TYPE)

const constructExistingPostTrigger = R.applySpec({
  type: R.always(COMMENTS_ON_TRIGGER_TYPE),
  data: R.prop('value'),
  operator: R.always('AND'),
  primary: R.T
})

const constructNewTextPostTrigger = R.applySpec({
  type: R.always(INITIAL_POST_TRIGGER_TYPE),
  result: R.always(COMMENTS_ON_TRIGGER_TYPE),
  primary: R.always(true),
  operator: R.always('AND'),
  data: {
    type: R.always('text'),
    endpoint: R.always('feed'),
    searchParams: {
      message: R.prop('postText')
    }
  }
})

const constructNewImagePostTrigger = R.applySpec({
  type: R.always(INITIAL_POST_TRIGGER_TYPE),
  result: R.always(COMMENTS_ON_TRIGGER_TYPE),
  primary: R.always(true),
  operator: R.always('AND'),
  data: {
    type: R.always('image'),
    endpoint: R.always('photos'),
    searchParams: {
      message: R.prop('postText'),
      url: R.prop('imageUrl')
    }
  }
})

const constructNewVideoPostTrigger = R.applySpec({
  type: R.always(INITIAL_POST_TRIGGER_TYPE),
  result: R.always(COMMENTS_ON_TRIGGER_TYPE),
  primary: R.always(true),
  operator: R.always('AND'),
  data: {
    type: R.always('video'),
    endpoint: R.always('videos'),
    searchParams: {
      description: R.prop('postText'),
      file_url: R.prop('videoUrl')
    }
  }
})

const convertCommentsOnFormTriggerToWidgetTrigger = R.cond([
  [R.propEq('action', 'EXISTING_POST'), constructExistingPostTrigger],
  [R.propEq('action', 'NEW_POST_TEXT'), constructNewTextPostTrigger],
  [R.propEq('action', 'NEW_POST_IMAGE'), constructNewImagePostTrigger],
  [R.propEq('action', 'NEW_POST_VIDEO'), constructNewVideoPostTrigger]
])

export { isCommentsOnFormTrigger, convertCommentsOnFormTriggerToWidgetTrigger }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/triggers/facebook/form-to-widget/comments-on-post.js